/**
 * 展示维度 icon 轻量常量与映射。
 *
 * @see types.ts · config.ts · utils.ts
 */

import {
  COUNTRY_FLAG_ICON_CODES,
} from '@/pages/home/_config/countries';
import {
  DimensionIconCategory,
  type TDimensionIconCategory,
} from './types';


/**
 * icon 选择弹窗左侧 Tab 分类 key（顺序即 UI 展示顺序）。
 *
 * @core DimensionMapSetModal Tab 顺序与 SHOW_DIMENSION_ICON 分类 key 对齐。
 */
export const SHOW_DIMENSION_ICON_CATEGORY_KEYS = [
  DimensionIconCategory.Platform,
  DimensionIconCategory.Sentiment,
  DimensionIconCategory.Country,
  DimensionIconCategory.Others,
] as const satisfies readonly TDimensionIconCategory[];


/**
 * 各分类下可选 icon key 列表（country 含国旗 code）。
 *
 * @core 配置面板选 icon 与 DimNumberTrendCard 展示读同一可选集合。
 */
export const SHOW_DIMENSION_ICON = {
  [DimensionIconCategory.Platform]: [
    'xbox',
    'Epics',
    'steam',
    'Playstation',
    'nintendo',
  ],
  [DimensionIconCategory.Sentiment]: [
    'sentiment_positive',
    'sentiment_negative',
    'sentiment_neutral',
  ],
  [DimensionIconCategory.Country]: [...COUNTRY_FLAG_ICON_CODES],
  [DimensionIconCategory.Others]: [
    'default',
    'iphone',
    'monitor',
    'console_line',
  ],
} as const satisfies Record<TDimensionIconCategory, readonly string[]>;

/**
 * 未指定颜色时 icon / 榜单条默认色板（循环使用）。
 *
 * @core showDimension config 中国旗/默认 icon 的 cololist 与榜单渲染共用。
 */
export const SHOW_DIMENSION_DEFAULT_COLOR = [
  '#5086F3',
  '#69D19C',
  '#6E7794',
  '#F8D74D',
  '#7F6FF1',
] as const;

/**
 * 平台类 icon 固定品牌色（与 config 中 color 字段对齐）。
 *
 * @core DimNumberTrendCard 榜单条品牌色与 icon 选择预览共用。
 */
export const SHOW_DIMENSION_ICON_COLOR = {
  xbox: '#107C10',
  epics: '#F8C800',
  steam: '#3E617F',
  playstation: '#0070D1',
  nintendo: '#EE0003',
} as const;
